/**
 * VAT Mode
 *
 * Indicates the VAT treatment (mechanism) of an invoice or line item.
 * The legal basis lives verbatim in `vatExemptionNote` / extraction `vatNote`.
 *
 * REVERSE_CHARGE: vatRate is set to the applicable rate (e.g., 21 %), but vatAmount = 0.
 *   The buyer accounts for the VAT themselves (§ 92a–92k).
 * EXEMPT_OTHER: both vatRate and vatAmount are 0 (supply is exempt from VAT).
 * EXEMPT_DOMESTIC / EXEMPT_EU_SUPPLY / EXEMPT_EXPORT: legacy subtype values —
 *   still valid on stored data and inputs, but no longer produced by extraction or the UI.
 */
export const VatMode = {
  STANDARD: 'STANDARD', // Standardní DPH — běžné zdanitelné plnění
  REVERSE_CHARGE: 'REVERSE_CHARGE', // Přenesená daňová povinnost (§ 92a–92k)
  EXEMPT_DOMESTIC: 'EXEMPT_DOMESTIC', // Legacy — osvobozeno, tuzemsko (§ 51–62)
  EXEMPT_EU_SUPPLY: 'EXEMPT_EU_SUPPLY', // Legacy — osvobozeno, dodání zboží do EU (§ 64)
  EXEMPT_EXPORT: 'EXEMPT_EXPORT', // Legacy — osvobozeno, vývoz zboží mimo EU (§ 66)
  EXEMPT_OTHER: 'EXEMPT_OTHER' // Osvobozeno od DPH (důvod nese vatExemptionNote)
} as const;

export type VatMode = (typeof VatMode)[keyof typeof VatMode];
